import React from 'react'
import { string } from 'prop-types'
import { useIntl } from 'react-intl'
import { followButton as messages } from '../messages'
import Button from './Button'
import { sendClickEventToInsights } from '../../../utils/insights'
import { sendEventToGTM } from '../../../utils/tag_manager'

const FollowButton = ({ type = '', id = '', slug = '', label = '', entity = '', filtersObject = '' }) => {
  const intl = useIntl()
  const followingLabel = intl.formatMessage({ ...messages.following })
  const unFollowLabel = intl.formatMessage({ ...messages.unfollow })
  const followLabel = intl.formatMessage({ ...messages.follow })
  const dataAttributes = {
    'data-follow-type': type,
    'data-follow-label': `${followLabel} ${label}`,
    'data-following-label': `${followingLabel} ${label}`,
    'data-unfollow-label': unFollowLabel,
    ...(id.length ? { 'data-follow-id': id } : {}),
    ...(slug.length ? { 'data-follow-slug': slug } : {})
  }
  const shouldRenderFollowButton = () => type && (id || slug)

  const onClickTracked = e => {
    e.stopPropagation()
    const actionType = isFollowing(e.target) ? 'unfollow' : 'follow'

    sendClickEventToInsights(`search-follow-button`, `${label}`, `${type}`, 'button', 'click')
    sendEventToGTM(entity, actionType, filtersObject)
  }

  const mainClasses = 'afd-suggestion__action afd-btn'
  return shouldRenderFollowButton() && (
    <div className='search__follow'>
      { /* eslint-disable-next-line max-len */}
      <Button mainClass={mainClasses} {...dataAttributes} onClick={onClickTracked}> {followLabel} {label} </Button>
    </div>
  )
}

const isFollowing = button => {
  if (!button.followButton) return false
  if (button.followButton.status === 'not-following') return false
  if (button.followButton.status === 'is-following') return true

  return false
}

FollowButton.propTypes = {
  type: string,
  id: string,
  slug: string,
  label: string
}

export default FollowButton
